// ── Material do Estratégia: ligação matéria do Ciclo ↔ grade do curso ──────────
// Visível só para a conta administradora (quem chama decide). O progresso fica dentro do
// registro do edital de cada usuário: editalStore.data.course = { done: { "slug:1.2": ts }, prog: { "slug:1.2": 1 } }.
import { ESTRATEGIA } from "../estrategia";

const norm = s => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
const SLUGS = [
  [/^portugues/, "portugues"],
  [/^informatica/, "informatica"],
  [/^direito constitucional/, "constitucional"],
  [/^legislacao de transito/, "transito"],
  [/^raciocinio logico/, "rlm"],
  [/^direito administrativo/, "administrativo"],
  [/^direito penal/, "penal"],
];

// Grade da matéria (ou null se o curso não tem essa matéria): { slug, label, mods }
export function estrFor(subjectName) {
  const n = norm(subjectName);
  const hit = SLUGS.find(([re]) => re.test(n));
  const c = hit && ESTRATEGIA[hit[1]];
  return c ? { slug: hit[1], label: c.label, mods: c.mods } : null;
}
export function estrBySlug(slug) {
  const c = ESTRATEGIA[slug];
  return c ? { slug, label: c.label, mods: c.mods } : null;
}
export const estrKey = (slug, aulaId) => `${slug}:${aulaId}`;
// Aulas planejadas no início da sessão (`estr` da sessão): novas guardam `aulas` (várias); antigas, só `aula`.
export const sessAulaIds = ce => (ce && Array.isArray(ce.aulas) && ce.aulas.length ? ce.aulas : ce && ce.aula ? [ce.aula] : []);
export const estrAulas = course => course.mods.flatMap(m => m.aulas);

// Primeira aula ainda não assistida (para já vir sugerida no início da sessão)
export function estrFirstPending(course, data) {
  const done = (data && data.course && data.course.done) || {};
  const a = estrAulas(course).find(x => !done[estrKey(course.slug, x.id)]);
  return a ? a.id : null;
}

// Aulas ligadas a uma sessão registrada (log do edital). Sessões novas guardam os ids em aulaIds.
// Nas antigas, as aulas concluídas na sessão têm a mesma data/hora do registro (done[chave] === log.at).
// Se nenhuma foi concluída mas havia uma aula escolhida, ela é devolvida como "em andamento".
export function estrSessionAulas(l, data) {
  const course = l && l.estr ? estrBySlug(l.estr) : null;
  if (!course) return { course: null, aulas: [], pending: false };
  let ids = Array.isArray(l.aulaIds) ? l.aulaIds.map(String) : null;
  if (!ids) {
    const done = (data && data.course && data.course.done) || {};
    const pre = l.estr + ":";
    ids = Object.keys(done).filter(k => k.startsWith(pre) && done[k] === l.at).map(k => k.slice(pre.length));
  }
  let pending = false;
  const plan = Array.isArray(l.aulasPlan) && l.aulasPlan.length ? l.aulasPlan : l.aula ? [l.aula] : [];
  if (!ids.length && plan.length) { ids = plan.map(String); pending = true; }
  const aulas = [];
  for (const m of course.mods) for (const a of m.aulas) if (ids.includes(String(a.id))) aulas.push({ id: a.id, t: a.t, modN: m.n, modT: m.t });
  return { course, aulas, pending };
}
